import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type DeleteDocumentAttachmentRequestType,
  deleteDocumentAttachment,
} from '..';
import { queryKey } from './query-key';

export const useDeleteDocumentAttachment = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, DeleteDocumentAttachmentRequestType>({
    mutationFn: (params: DeleteDocumentAttachmentRequestType) =>
      deleteDocumentAttachment(params),
    onSuccess: async (_data, variables) => {
      await queryClient.refetchQueries(
        queryKey.documentAttachments(variables.documentId),
      );
    },
  });
};
